import CustomInput from "@src/components/CustomInput";
import CustomMaskInput from "@src/components/CustomMaskInput";

export const GsmInputComponent = (props) => (
    <CustomMaskInput
        id="ticketRestaurant-manageMyCards-activeCardList-GsmInputComponent-maskInput"
        {...props}
        mask={String.raw`+\90 (999) 999 99 99`}
    >
        <CustomInput
            id="ticketRestaurant-manageMyCards-activeCardList-GsmInputComponent-input"
            placeholder={'+90 (___) ___ __ __'}
            height={36}
        />
    </CustomMaskInput>
);